import { Select } from '@headlessui/react';
import { useElementSize } from '@mantine/hooks';
import sortBy from 'lodash.sortby';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Chart from 'react-apexcharts';

const TopServiceCategories = ({ data = [] }) => {
	const { ref, width } = useElementSize();
	const [groupBy, setGroupBy] = useState('client_birth_year');
	console.log(...new Set(data.map((row) => row[groupBy])));
	const chartData = data.reduce((prev, row) => {
		if (!prev[row.service_category]) {
			prev[row.service_category] = 1;
		} else {
			prev[row.service_category]++;
		}
		return prev;
	}, {});
	const mappedData = sortBy(
		Object.entries(chartData).map(([category, count]) => ({
			category,
			count,
		})),
		['count'],
	).reverse();
	const categories = mappedData.map(({ category }) => category);
	const seriesData = mappedData.map(({ count }) => count);
	const height = Math.max(mappedData.length * 50, 100);
	return (
		<div ref={ref}>
			<div className="flex flex-row">
				<div className="self-center text-xl grow">Top Service Categories</div>
				<Select
					className="select select-sm select-bordered"
					value={groupBy}
					onChange={({ target }) => setGroupBy(target.value)}
				>
					<option value="client_birth_year">Year</option>
					<option value="client_zip">Zip Code</option>
				</Select>
			</div>
			<Chart
				type="bar"
				width={width}
				height={height}
				options={{
					chart: { stacked: true },
					colors: ['#3abddb'],
					xaxis: { categories },
					plotOptions: {
						bar: {
							horizontal: true,
						},
					},
				}}
				series={[{ name: 'Count', data: seriesData }]}
			/>
		</div>
	);
};

TopServiceCategories.propTypes = {
	data: PropTypes.array,
};

export default TopServiceCategories;
